import { Link } from 'react-router-dom';

export function DocNotFound() {
    return (
        <div className="doc-not-found">
            <h1>文档未找到</h1>
            <p>请求的文档不存在或尚未发布。</p>
            <Link to="/">返回首页</Link>
        </div>
    );
}
